<template>
  <v-app :class="appClass" :style="appStyle" class="d-flex flex-column">
    <!-- HEADER SOLO CUANDO NO ESTÁ LOGUEADO -->
    <Header v-if="showHeader"/>
      <!-- APP TOP BAR -->
      <app-bar
        v-if="showAppBar"
        @openCloseDrawer="toggleDrawer"
        :pDrawer="drawer"
        v-click-outside="onClickOutside"
        @onResizeWidth="onResize"
      />

      <!-- LEFT SIDE MENU -->
      <navigation-drawer
        v-if="showNavigationDrawer"
        @openCloseDrawerOutside="toggleDrawer"
        :pDrawer="drawer"
      />

      <v-main class="bg_main page-bg flex-grow-1 pageprincipal">
        <alert/>
        <loading/>
        <router-view/>
      </v-main>
    <Footer v-if="showFooter" style="margin-top: 10rem;"/>
  </v-app>
</template>

<script>
import Footer from "@/components/Footer.vue";
// import preventInspector from "@/config/antinspector"
import AppBar from "./components/AppBar";
import NavigationDrawer from "./components/NavigationDrawer";
import Alert from "./components/Alert";
import Loading from "./components/Loading";
import Header from "./components/Header";
import vClickOutside from "v-click-outside";
import {mapActions, mapState} from "vuex";

export default {
  name: "App",
  components: {Footer, AppBar, NavigationDrawer, Alert, Loading, Header},
  directives: {clickOutside: vClickOutside.directive},
  computed: {
    ...mapState({account: (state) => state.account}),
    appClass() {
      return this.account.loggedIn && this.account.confirmado === "1" ? "" : "fondo_login";
    },
    showFooter() {
      return !this.account.loggedIn || this.account.confirmado !== "1";
    },
    appStyle() {
      return this.account.loggedIn && this.account.confirmado === "1"
        ? {backgroundImage: "none"}
        : {backgroundImage: `url(${this.base64(this.$vuetify.theme.themes.light.main_color)})`};
    },
    showAppBar() {
      return this.account.loggedIn && this.$router.currentRoute.name !== "documents_validate" && this.account.confirmado === "1";
    },
    showNavigationDrawer() {
      return this.showAppBar;
    },
    showHeader() {
      return !this.account.loggedIn || this.account.confirmado !== "1";
    }
  },
  methods: {
    ...mapActions("account", ["checkLogin"]),
    ...mapActions("keycloakModule", ["initRefreshTimer"]),
    onClickOutside() {
      if (this.drawer && this.widthSize < 900) {
        this.drawer = false;
      }
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    onResize(width) {
      this.widthSize = width;
      if (width === 900 && this.drawer) {
        this.drawer = false;
      }
    },
    base64(val) {
      let svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1920 1080'>
                    <style>.bg{fill:${val}; opacity: 0.8;}</style>
                    <rect width='1920' height='1080' class='bg'/>
                  </svg>`;
      return `data:image/svg+xml,${encodeURIComponent(svg)}`;
    }
  },
  created() {
    this.checkLogin();
    this.initRefreshTimer();
  },
  mounted() {
    this.drawer = window.innerWidth >= 900;
    // preventInspector();
  },
  data() {
    return {
      drawer: null,
      widthSize: window.innerWidth
    };
  }
};
</script>

<style lang="scss" scoped>
.fondo_login {
  background-color: white;
  background-repeat: no-repeat;
  background-position: bottom;
  width: 100vw;
  background-size: cover;
}

.logo_login_img {
  display: flex;
  padding: calc(1vh + 5vw) 0 5vh 5vw;
}

.logo_login_img img {
  max-width: 400px;
  max-height: 250px;
}

@media (max-width: 767px) {
  .logo_login_img {
    justify-content: center;
    padding: 8vh 0 10vh 0;
  }
  .logo_login_img img {
    max-width: 250px;
    max-height: 150px;
  }
}

.page-bg {
  background-image:
      linear-gradient(rgba(234, 229, 229, 0.4), rgba(255, 255, 255, 0.4)),
      url('~@/assets/img/frame_background.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
}
</style>
